import { useSession } from '~/contexts/SessionContext';
import { StructureSetService } from '~/domain/services/structureSet/StructureSetService';

export function useStructureSetService(): StructureSetService {
    return useSession().structureSetService;
}
